import { watch } from 'vue';
import { useStates } from '../router/states';
import type { UserState } from '../common/definitions/user';

export function useTitle() {
  const { userState } = useStates() as { userState: UserState };

  const updateTitle = () => {
    if (!userState?.data?.value) return;
    const companyName = userState?.data?.value?.nameCompany;
    document.title = companyName ? `${companyName}` : 'CONTIFAST';
  };

  // Watch for changes in the company name
  watch(
    () => userState?.data?.value?.nameCompany,
    () => {
      updateTitle();
    },
  );

  // Initial title update
  updateTitle();

  return {
    updateTitle,
  };
}
